import React from 'react';

import {
  InterimContent,
  LIST_DISPLAY_TYPE,
  ListDisplayType,
} from '@/constants';

import styles from './FixedInterimView.module.scss';
import { useLanguageRTL } from './hooks/useLanguageTRL';
import { InterimView } from './InterimView';

/**
 * プロパティ
 */
export type FixedInterimView = {
  // 表示タイプ
  displayType: ListDisplayType;
  // 暫定テキスト情報
  interimContent: InterimContent;
};

/**
 * 固定表示用暫定テキストビュー コンポーネント
 */
export const FixedInterimView = React.memo(
  ({ displayType, interimContent }: FixedInterimView) => {
    const { isSrcLangRTL, isDestLangRTL } = useLanguageRTL();

    /**
     * RTLスタイルを適用すべきかどうかを判定
     *
     * @param content 暫定テキスト情報
     * @param isDisplayingSourceText 現在表示しているのが元言語のテキストか（true=元言語、false=翻訳先言語）
     * @returns RTLスタイルを適用するか
     */
    const shouldApplyRTLStyle = (
      content: InterimContent,
      isDisplayingSourceText: boolean,
    ): boolean => {
      if (isDisplayingSourceText) {
        return content.isReversed
          ? isDestLangRTL(content.destlang)
          : isSrcLangRTL(content.srclang);
      }

      return content.isReversed
        ? isSrcLangRTL(content.srclang)
        : isDestLangRTL(content.destlang);
    };

    return (
      <div className={`${styles[`interim-fixed-footer`]}`}>
        {displayType === LIST_DISPLAY_TYPE.onePhrase ? (
          <InterimView
            isReversed={interimContent.isReversed}
            langCode={
              interimContent.isReversed
                ? interimContent.srclang
                : interimContent.destlang
            }
            text={
              interimContent.isReversed
                ? interimContent.stt
                : interimContent.ttt
            }
            isAutoLeftScrollInterimText
            isRTL={shouldApplyRTLStyle(interimContent, false)}
          />
        ) : (
          <>
            <div className={styles['interim-fixed-content']}>
              <InterimView
                isReversed={!interimContent.isReversed}
                langCode={
                  !interimContent.isReversed
                    ? interimContent.srclang
                    : interimContent.destlang
                }
                text={
                  !interimContent.isReversed
                    ? interimContent.stt
                    : interimContent.ttt
                }
                isAutoLeftScrollInterimText
                isRTL={shouldApplyRTLStyle(interimContent, true)}
              />
            </div>
            <div className={`${styles['interim-fixed-content']}`}>
              <InterimView
                isReversed={interimContent.isReversed}
                langCode={
                  !interimContent.isReversed
                    ? interimContent.destlang
                    : interimContent.srclang
                }
                text={
                  !interimContent.isReversed
                    ? interimContent.ttt
                    : interimContent.stt
                }
                isAutoLeftScrollInterimText
                isRTL={shouldApplyRTLStyle(interimContent, false)}
              />
            </div>
          </>
        )}
      </div>
    );
  },
);
